import { useRef, useCallback, useEffect } from 'react';

/**
 * Custom hook to manage a timeout for executing a callback function
 * Cancels previous timeout when called again
 * @param {Function} callback - The function to call after the timeout
 * @param {number} delay - Timeout duration in ms (default: 5000)
 */
export default function useSavingTimeout(callback, delay = 3000) {
  const timeoutRef = useRef(null);

  const startSavingTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    // Set new timeout
    timeoutRef.current = setTimeout(() => {
      callback();
      timeoutRef.current = null;
    }, delay);
  }, [callback, delay]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, []);

  return startSavingTimeout;
}
